import VideoPage from "./VideoPage";

export default VideoPage;
